<script>
  import { _ } from "svelte-i18n";
  import { GENERIC_DOCS_URL } from "utils/menu";
  import { GENERIC_DOCS_VERSION, GENERIC_DOCS_SOURCE } from "utils/document";
  import Document from "routes/Documents/Document.svelte";
  import { onMount } from "svelte";
  import { trackEvent } from "utils/analytics";

  // Retrieve active page or default to intro
  const path = window.location.pathname?.replace("/docs/", "");
  export let params = { wild: path ?? "most-common" };
  export let defaultSubPage = "most-common";

  $: displayTitle = $_("documents.genericTitle");

  onMount(() => {
    trackEvent("PageView", {
      page: "GenericDocs",
      ...params,
    });
  });
</script>

<Document
  documentSourceUrl={GENERIC_DOCS_SOURCE}
  documentVersion={GENERIC_DOCS_VERSION}
  baseDocumentUrl={GENERIC_DOCS_URL}
  menuTitle={displayTitle}
  {params}
  {defaultSubPage}
/>
